/* eslint-disable sort-keys */ export const fontSizeToPixelMap = {
    xs: 11,
    s: 12,
    m: 13,
    l: 15,
    xl: 17,
    '2xl': 21,
    '3xl': 27,
    '4xl': 34,
    '5xl': 40,
    '6xl': 48,
    '7xl': 54
};

//# sourceMappingURL=font-size.js.map